@if (company && !branchFailedToLoad) {
  <div>
    @if (!isEditingBranch) {
      <h1 class="content-main-title">{{ 'content.create-new-branch' | translate }} {{ company.companyName }}</h1>
    }
    @if (isEditingBranch) {
      <h1 class="content-main-title">{{ 'content.edit-branch' | translate }} {{ company.companyName }}</h1>
    }
    <div class="d-flex justify-content-end">{{ 'content.all.required-field-explanation' | translate }}</div>
    <mat-vertical-stepper #stepper [linear]="true">
      <mat-step #step1 [completed]="false" [editable]="!isEditingBranch">
        <form [formGroup]="f1" [ngClass]="{'form-submitted': memberCodeFormSubmitted}" (submit)="submitMemberCode(f1.value)">
          <ng-template matStepLabel><h2>{{ enteredMemberCode ? enteredMemberCode : ('content.member-code' | translate) }}</h2></ng-template>
          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="memberCode">{{ 'content.member-code' | translate }} *
                <input id="memberCode" class="form-control" type="text" autocomplete="on" formControlName="memberCode" #memberCodeInput>
              </label>
              <app-validation-errors [displayErrors]="memberCodeFormSubmitted" [errors]="c1.memberCode.errors" [element]="memberCodeInput"></app-validation-errors>
            </div>
          </div>
          <div class="d-flex justify-content-end inline-gap-5 submit-buttons">
            <button class="tu-button secondary tu-shadow" type="button" [routerLink]="['/admin/companies', company.companyName, 'details']">{{ 'content.cancel' | translate }}</button>
            <button class="tu-button primary tu-shadow" type="submit">{{ 'content.next' | translate }}</button>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <form [formGroup]="f2" [ngClass]="{'form-submitted': memberCodeDetailsFormSubmitted}" (submit)="submitMemberCodeDetails(f2.value)">
          <ng-template matStepLabel><h2>{{ 'content.details' | translate }}</h2></ng-template>
          <h3>{{ 'content.person.name' | translate }}</h3>
          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="branchName">{{ 'content.branch-name' | translate }}  *
                <input id="branchName" class="form-control" type="text" autocomplete="on" formControlName="branchName" #branchNameElement>
              </label>
              <app-validation-errors [displayErrors]="memberCodeDetailsFormSubmitted" [errors]="c2.branchName.errors" [element]="branchNameElement"></app-validation-errors>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6 col-sm-12">
              <label>{{ 'content.products' | translate }}  *
                <select class="form-select" formControlName="product" #productInput>
                  <option value=""></option>
                  @for (product of (allProducts | keyvalue); track product) {
                    <option value="{{ product.key }}">{{ product.value }}</option>
                  }
                </select>
              </label>
              <app-validation-errors [displayErrors]="memberCodeDetailsFormSubmitted" [errors]="c2.product.errors" [element]="productInput"></app-validation-errors>
            </div>
          </div>
          <h3>{{ 'content.reference-number' | translate }}</h3>
          <div class="form-row">
            <div class="col-md-4 ps-0">
              <input id="refAutoGenerated" class="form-check-input ms-2" type="checkbox" formControlName="refAutoGenerated">
              <label class="form-check-label col-md-10" for="refAutoGenerated">{{ 'content.auto-generated' | translate }}</label>
            </div>
          </div>
          <div class="d-flex justify-content-end inline-gap-5 submit-buttons">
            <button class="tu-button secondary tu-shadow" type="button" [routerLink]="['/admin/companies', company.companyName, 'details']">{{ 'content.cancel' | translate }}</button>
            @if (!isEditingBranch) {
              <button class="tu-button secondary tu-shadow" type="button" matStepperPrevious>{{ 'content.back' | translate }}</button>
            }
            <button class="tu-button primary tu-shadow" type="submit">{{ 'content.submit' | translate }}</button>
          </div>
        </form>
      </mat-step>
    </mat-vertical-stepper>
  </div>
}
@if (companyFailedToLoad) {
  <div>
    {{ 'content.company-not-found' | translate:{companyName: companyNameParam} }}
  </div>
}
@if (branchFailedToLoad) {
  <div>
    {{ 'content.item-not-found' | translate:{item: branchNameParam} }}
  </div>
}
